export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-trees-1b9549c78f6cbff7a59f32828f9b5386.svg";